import axiosInstance from '../../api/axiosInstance';

const getMedineerTestSeries = async ({
    pageNumber = 1,
    pageSize = 100,
    objective = null,
}) => {
    const response = await axiosInstance.get('/api/Courses', {
        params: {
            pageNumber,
            pageSize,
            contentFilter: 0,
            contentCuratorIds: null,
            objective,
            isMedineerLogin: true,
        },
    });

    const list = response?.data?.$values || [];
    const totalItems = list[0]?.totalCount || 0;

    return {
        list,
        totalItems,
    };
};

export default getMedineerTestSeries;
